import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { LoginLayout } from './components/loginLayout';
import { useAppConfigurations } from '@roc/client-portal-shared/hooks';
import { createStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import { LoginLogoImg } from '@roc/feature-app-core';

const useStyles = makeStyles(theme =>
  createStyles({
    gridContainer: {
      padding: theme.spacing(4),
      maxWidth: 500,
      margin: 'auto',
    },
  })
);

export const SuccessForgotPasswordEmail = () => {
  const classes = useStyles();
  const { data } = useAppConfigurations();
  return (
    <LoginLayout>
      <Grid container justifyContent="center" className={classes.gridContainer}>
        <Grid container item xs={12} spacing={4}>
          <Grid item xs={12}>
            <LoginLogoImg />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h4" align="center">
              An email was successfully sent!
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1" align="center">
              Please check your inbox and follow the link in the mail to create
              a new password.
            </Typography>
          </Grid>
          {data.phoneNumber && (
            <>
              <Grid item xs={12}>
                <Typography variant="body1" align="center">
                  If you need further assistance, please contact us at:
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h6" align="center">
                  {data.phoneNumber}
                </Typography>
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
    </LoginLayout>
  );
};
